// extracted by mini-css-extract-plugin
module.exports = {"container":"NoteSlat__container--20Lz87cE90"};